import { Globals } from "../global/Globals";
import React from "react";
import { Navigate } from "react-router-dom";
import CryptoUtils from "../util/cryptoUtils";

const ProtectedRouter = ({children}) => {
  const isAuthenticated = () => {
  const hasLocalStorageItem = CryptoUtils?.getFromLocalStorage("isCookieAvailable") !== null;
  const hasJwtCookie = CryptoUtils?.getFromCookie(Globals.JWT_TOKEN_NAME) !== null;
  return hasLocalStorageItem || hasJwtCookie;
    };
  return isAuthenticated() ? children :< Navigate to="/" />
};

export default ProtectedRouter;



